export function configure(aurelia) {
  aurelia
    .globalResources(PLATFORM.moduleName('./vui-u-pull-left'));
}
